export default "__VITE_ASSET__BB$V72uM__"